import {
  mediaUrl,
  payUrl,
  serverUrl,
  stompUrl,
  wmsUrl
} from '../environments/environment';

import {
  Discount,
  DiscountWms
} from '../models';

export const _MEDIA_URL = mediaUrl;
export const _PAY_URL = payUrl;
export const _SERVER_URL = serverUrl;
export const _STOMP_URL = stompUrl;
export const _WMS_URL = wmsUrl;

export const COST_LIST_MARKUP_DEFAULT_MAP = {
  delivery: 6,
  cod: 1,
  servicesExtra: 0,
  surcharges: 0,
  insurance: 0,
  returns: 6
}; // % (percent)

export const COUNTRY_PARTNER_CODE_OVERRIDE_MAP = {
  'at': 'IT-BZ',
  'bg': 'HU-BU',
  'cz': 'HU-BU',
  'de': 'DE-LZ,IT-BZ',
  'fr': 'IT-BZ',
  'hr': 'HU-BU',
  'it': 'IT-BZ',
  'eu': 'DE-LZ',
  'pl': 'HU-BU',
  'pt': 'ES-VL',
  'ro': 'HU-BU',
  'hu': 'HU-BU',
  'si': 'HU-BU',
  'sk': 'HU-BU',
  'non-eu': 'DE-LZ',
  'intl': 'DE-LZ'
};

export const COUNTRY_PARTNER_CODES_DEACTIVATED = [
  'DE-BE',
  'DE-BZ',
  'ST-RO'
];

export const WAREHOUSE_PARTNER_CODE_MAP = {
  'IT': 'BIZOMIT',
  'BG': 'BIZINBG',
  'HU': 'BIZALLPHU',
  'RO': 'BIZALLPRO',
  'CY': 'BIZACSCY',
  'ES': 'BIZAS',
  'PT': 'BIZASMENPT',
  'GR': 'BIZGR',
  'DE': 'BIZLEIP'
};

export const COUNTRY_PARTNER_CODE_OVERRIDE_MAP_WMS = {
  'de': 'DE-LZ',
  'it': 'IT-BZ'
};

export const COUNTRY_REGION_LABEL_MAP = {
  'es': [
    {
      'label': 'Balearic Main Islands',
      'regionCodes': [
        '10000041'
      ]
    },
    {
      'label': 'Balearic Menor Islands',
      'regionCodes': [
        '10000042'
      ]
    },
    {
      'label': 'Canary Main Islands',
      'regionCodes': [
        '10000043'
      ]
    },
    {
      'label': 'Canary Menor Islands',
      'regionCodes': [
        '10000044'
      ]
    },
    {
      'label': 'Ceuta & Melilla',
      'regionCodes': [
        '10000040'
      ]
    }
  ],
  'gr': [
    {
      'label': 'Outside Attiki',
      'regionCodes': [
        '10000047'
      ]
    },
    {
      'label': 'Islands',
      'regionCodes': [
        '10000048'
      ]
    },
    {
      'label': 'Inaccessible Areas',
      'regionCodes': [
        '10000049'
      ]
    },
  ],
  'pt': [
    {
      'label': 'Azores Islands',
      'regionCodes': [
        '10000045'
      ]
    },
    {
      'label': 'Madeira Islands',
      'regionCodes': [
        '10000046'
      ]
    }
  ],
  'it': [
    {
      'label': 'Sicily',
      'regionCodes': [
        '10000051'
      ]
    },
    {
      'label': 'Corsica',
      'regionCodes': [
        '10000052'
      ]
    },
    {
      'label': 'Sardinia',
      'regionCodes': [
        '10000053'
      ]
    }
  ]
};

export const COUNTRY_ZONE_MAP = {
  'eu': 'European Union',
  'non-eu': 'Outside European Union',
  'intl': 'International'
};

export const DEFAULT_CURRENCY_CODE = 'EUR';
export const DEFAULT_LANGUAGE_CODE = 'en';

export const DEFAULT_LOCALES = [
  {
    name: 'gr',
    delimiters: {
      thousands: '.',
      decimal: ','
    }
  },
  {
    name: 'intl',
    delimiters: {
      thousands: ',',
      decimal: '.'
    }
  }
];

export const PAGE_SCROLL_MARGIN_TOP = 120;
export const PAGE_SCROLL_MARGIN_TOP_FIRST = 0;

export const PREFERRED_COUNTRY_CODES = [
  'at',
  'be',
  'bg',
  'cy',
  'cz',
  'de',
  'en',
  'es',
  'fr',
  'gr',
  'hr',
  'hu',
  'lu',
  'nl',
  'it',
  'pl',
  'pt',
  'ro',
  'sk',
  'si'
];

export const PRICELIST_DISCOUNT_DEFAULTS: Discount[] = [
  {
    labelSuffix: 'Business',
    ratios: {
      delivery: 10,
      cod: 5,
      servicesExtra: 0,
      surcharges: 0,
      insurance: 0,
      returns: 10
    }
  },
  {
    labelSuffix: 'Discount B',
    ratios: {
      delivery: 15,
      cod: 5,
      servicesExtra: 0,
      surcharges: 0,
      insurance: 0,
      returns: 15
    }
  },
  {
    labelSuffix: 'Discount C',
    ratios: {
      delivery: 20,
      cod: 7.5,
      servicesExtra: 0,
      surcharges: 0,
      insurance: 0,
      returns: 20
    }
  },
  {
    labelSuffix: 'Discount D',
    ratios: {
      delivery: 25,
      cod: 7.5,
      servicesExtra: 0,
      surcharges: 0,
      insurance: 0,
      returns: 25
    }
  },
  {
    labelSuffix: 'Partner',
    ratios: {
      delivery: 35,
      cod: 12.5,
      servicesExtra: 0,
      surcharges: 0,
      insurance: 0,
      returns: 35
    }
  },
  {
    labelSuffix: 'Reseller',
    ratios: {
      delivery: 30,
      cod: 10,
      servicesExtra: 0,
      surcharges: 0,
      insurance: 0,
      returns: 30
    }
  }
];

export const PRICELIST_WMS_DISCOUNT_DEFAULTS: DiscountWms[] = [
  {
    labelSuffix: 'Business',
    ratios: {}
  },
  {
    labelSuffix: 'Discount B',
    ratios: {}
  },
  {
    labelSuffix: 'Discount C',
    ratios: {}
  },
  {
    labelSuffix: 'Discount D',
    ratios: {}
  },
  {
    labelSuffix: 'Partner',
    ratios: {}
  },
  {
    labelSuffix: 'Reseller',
    ratios: {}
  }
];


export const PRICELIST_DISCOUNT_DEFAULT_MAP = {
  delivery: null,
  cod: null,
  servicesExtra: null,
  surcharges: null,
  insurance: null,
  returns: null
}; // % (percent)

export const PRICELIST_OFFICIAL_DEFAULT = {
  labelSuffix: 'Basic'
};

export const PRICELIST_MARKUP_DEFAULT_MAP = {
  delivery: 70,
  cod: 30,
  servicesExtra: 0,
  surcharges: 0,
  insurance: 0,
  returns: 70
}; // % (percent)

export const PRICELIST_SERVICE_CODES_LEGACY_DEFAULT = [
  '001',
  '22'
];

export const RATE_RETURN_TYPES = [
  'free',
  'fixed',
  'stepped'
];

export const RATE_UNIT_FRANKING_TYPES = [
  'full',
  'unit'
];

export const SEARCH_MIN_CHARACTERS = 3;

export const VAT_RATES = [
  0.27,
  0.24,
  0.23,
  0.22,
  0.21,
  0.20,
  0.19,
  0.16,
  0.13,
  0.135,
  0.09,
  0.07,
  0.06,
  0.05,
  0.048,
  0
];
